export default {
  // 商城规则
  mallSetting: {
    url: '/mall/product/rule/mallSetting',
    type: 'get'
  }
}
